import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancelButtonLabel: {
    id: "notificationBouncedEmailModal.cancelButtonLabel",
    defaultMessage: "Cancel",
    description: "Notification Bounced Email Modal - cancel button label",
  },
  companyLabel: {
    id: "notificationBouncedEmailModal.personLabel",
    defaultMessage: "Company",
    description: "Notification Bounced Email Modal - company label",
  },
  emailChangedDescription: {
    id: "notificationBouncedEmailModal.emailChangedDescription",
    defaultMessage:
      "The previous email may have had a typo or didn’t exist. This record now has a new email address: “{email}”.",
    description: "Notification Bounced Email Modal - email changed title",
  },
  emailChangedTitle: {
    id: "notificationBouncedEmailModal.emailChangedTitle",
    defaultMessage: "This email wasn’t delivered, but the address has since been updated.",
    description: "Notification Bounced Email Modal - email changed title",
  },
  emailLabel: {
    id: "notificationBouncedEmailModal.emailLabel",
    defaultMessage: "Email",
    description: "Notification Bounced Email Modal - email label",
  },
  emailNotDeliveredKnownEmailDescription: {
    id: "notificationBouncedEmailModal.emailNotDeliveredKnownEmailDescription",
    defaultMessage:
      "The email address “{email}” could have a typo or does not exist, so this email was not received.",
    description: "Notification Bounced Email Modal - email not delivered known email description",
  },
  emailNotDeliveredTitle: {
    id: "notificationBouncedEmailModal.emailNotDeliveredTitle",
    defaultMessage: "Email not delivered",
    description: "Notification Bounced Email Modal - email not delivered title",
  },
  emailNotDeliveredUnknownEmailDescription: {
    id: "notificationBouncedEmailModal.emailNotDeliveredUnknownEmailDescription",
    defaultMessage:
      "The email address could have a typo or does not exist, so this email was not received.",
    description: "Notification Bounced Email Modal - email not delivered unknown email description",
  },
  entityUpdatedSuccessfullyMessage: {
    id: "notificationBouncedEmailModal.entityUpdatedSuccessfullyMessage",
    defaultMessage: "{entityName} updated successfully",
    description: "Notification Bounced Email Modal - entity updated successfully message",
  },
  noEmailDescription: {
    id: "notificationBouncedEmailModal.noEmailDescription",
    defaultMessage:
      "The previous email may have had a typo or didn’t exist. For now this record does not have an email address.",
    description: "Notification Bounced Email Modal - no email description",
  },
  openRecordButtonLabel: {
    id: "notificationBouncedEmailModal.openRecordButtonLabel",
    defaultMessage: "Open Record",
    description: "Notification Bounced Email Modal - open record button label",
  },
  personLabel: {
    id: "notificationBouncedEmailModal.personLabel",
    defaultMessage: "Person",
    description: "Notification Bounced Email Modal - person label",
  },
  saveButtonLabel: {
    id: "notificationBouncedEmailModal.saveButtonLabel",
    defaultMessage: "Save",
    description: "Notification Bounced Email Modal - save button label",
  },
  unsubscribeButtonLabel: {
    id: "notificationBouncedEmailModal.unsubscribeButtonLabel",
    defaultMessage: "Unsubscribe",
    description: "Notification Bounced Email Modal - unsubscribe button label",
  },
  updateEmailButtonLabel: {
    id: "notificationBouncedEmailModal.updateButtonLabel",
    defaultMessage: "Update Email Address",
    description: "Notification Bounced Email Modal - update email button label",
  },
  updateEmailDescription: {
    id: "notificationBouncedEmailModal.updateEmailDescription",
    defaultMessage: "Fill in the corrected email below and tap save to update this field.",
    description: "Notification Bounced Email Modal - update email description",
  },
  updateEmailTitle: {
    id: "notificationBouncedEmailModal.updateEmailTitle",
    defaultMessage: "Update Email",
    description: "Notification Bounced Email Modal - update title",
  },
});

export default messages;
